const FilterIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 3.5C8.05228 3.5 8.5 3.94772 8.5 4.5V8.5C8.5 9.05228 8.05228 9.5 7.5 9.5C6.94772 9.5 6.5 9.05228 6.5 8.5V4.5C6.5 3.94772 6.94772 3.5 7.5 3.5ZM16.5 3.5C17.0523 3.5 17.5 3.94772 17.5 4.5V5.62602C19.2252 6.07006 20.5 7.63616 20.5 9.5C20.5 11.7091 18.7091 13.5 16.5 13.5C14.2909 13.5 12.5 11.7091 12.5 9.5C12.5 7.63616 13.7748 6.07006 15.5 5.62602V4.5C15.5 3.94772 15.9477 3.5 16.5 3.5ZM16.5 7.5C15.3954 7.5 14.5 8.39543 14.5 9.5C14.5 10.6046 15.3954 11.5 16.5 11.5C17.6046 11.5 18.5 10.6046 18.5 9.5C18.5 8.39543 17.6046 7.5 16.5 7.5ZM7.5 12.5C6.39543 12.5 5.5 13.3954 5.5 14.5C5.5 15.6046 6.39543 16.5 7.5 16.5C8.60457 16.5 9.5 15.6046 9.5 14.5C9.5 13.3954 8.60457 12.5 7.5 12.5ZM3.5 14.5C3.5 12.2909 5.29086 10.5 7.5 10.5C9.70914 10.5 11.5 12.2909 11.5 14.5C11.5 16.3638 10.2252 17.9299 8.5 18.374V19.5C8.5 20.0523 8.05228 20.5 7.5 20.5C6.94772 20.5 6.5 20.0523 6.5 19.5V18.374C4.77477 17.9299 3.5 16.3638 3.5 14.5ZM16.5 14.5C17.0523 14.5 17.5 14.9477 17.5 15.5V19.5C17.5 20.0523 17.0523 20.5 16.5 20.5C15.9477 20.5 15.5 20.0523 15.5 19.5V15.5C15.5 14.9477 15.9477 14.5 16.5 14.5Z"
        fill="white"
      />
    </svg>
  );
};

export default FilterIcon;
